import React from 'react'

import { useVideoPreviewSettingsContext } from '../VideoPreviewSettingsContext'

export const VideoPreviewLogo = () => {
  const { logoSrc, logoSize, logoPosition } = useVideoPreviewSettingsContext()

  if (!logoSrc) return null

  return (
    <div
      className={`video-page-view-logo-wrapper video-page-view-logo-wrapper-${logoPosition}`}
    >
      <img
        className="video-page-view-logo"
        src={logoSrc}
        alt="Site logo"
        style={{ width: `${logoSize}px` }}
      />
    </div>
  )
}
